export default [
    {
      id: 1,
      name: 'Bertie Yates',
      phone: '0666666666',
      image:
        'https://randomuser.me/api/portraits/women/63.jpg',
    },
    {
      id: 2,
      name: 'Hester Hogan',
      phone: '0666666668',
      image:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1595959131/person-3_rxtqvi.jpg',
    },
    {
      id: 3,
      name: 'Larry Little',
      phone: '0666666669',
      image:
        'https://randomuser.me/api/portraits/men/46.jpg',
    },

  ];